import React, { useState, useEffect } from 'react'
import { Clock, AlertTriangle } from 'lucide-react'

interface SessionStatusProps {
  timeRemaining: number
  onExtendSession: () => void
}

const SessionStatus: React.FC<SessionStatusProps> = ({ timeRemaining, onExtendSession }) => {
  const [showWarning, setShowWarning] = useState(false)
  const [displayTime, setDisplayTime] = useState(timeRemaining)

  // Atualiza o tempo de exibição a cada segundo
  useEffect(() => {
    setDisplayTime(timeRemaining)
    
    const interval = setInterval(() => {
      setDisplayTime(prev => {
        const newTime = Math.max(0, prev - 1/60) // Decrementa 1 segundo (1/60 de minuto)
        return newTime
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [timeRemaining])

  useEffect(() => {
    if (displayTime <= 5 && displayTime > 0) {
      setShowWarning(true)
    } else {
      setShowWarning(false)
    }
  }, [displayTime])

  const formatTime = (minutes: number) => {
    if (minutes <= 0) {
      return '0min'
    }
    
    const totalSeconds = Math.floor(minutes * 60)
    const hours = Math.floor(totalSeconds / 3600)
    const mins = Math.floor((totalSeconds % 3600) / 60)
    const secs = totalSeconds % 60

    if (hours > 0) {
      return `${hours}h ${mins.toString().padStart(2, '0')}min ${secs.toString().padStart(2, '0')}s`
    } else if (mins > 0) {
      return `${mins}min ${secs.toString().padStart(2, '0')}s`
    } else {
      return `${secs}s`
    }
  }

  if (timeRemaining <= 0) {
    return null
  }

  return (
    <div className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm ${
      showWarning 
        ? 'bg-orange-100 text-orange-800 border border-orange-200' 
        : 'bg-blue-100 text-blue-800 border border-blue-200'
    }`}>
      {showWarning ? (
        <AlertTriangle className="h-4 w-4" />
      ) : (
        <Clock className="h-4 w-4" />
      )}
      <span>
        {showWarning ? 'Sessão expira em' : 'Sessão:'} {formatTime(displayTime)}
      </span>
      {showWarning && (
        <button
          onClick={onExtendSession}
          className="ml-2 px-2 py-1 bg-orange-600 text-white text-xs rounded hover:bg-orange-700 transition-colors"
        >
          Estender
        </button>
      )}
    </div>
  )
}

export default SessionStatus
